// extracted by mini-css-extract-plugin
module.exports = {"embla":"styles_embla__neK8z"};